import { Controller } from "@hotwired/stimulus"
import { playPing } from "../utils/ping"

// Auto-dismissing toast notification. Attach to each toast element via
// data-controller="toast" and (optional) data-toast-duration-value="5000".
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 5000 },
    ping: { type: Boolean, default: true }
  }

  connect() {
    requestAnimationFrame(() => this.element.classList.add("toast--enter"))
    if (this.pingValue) playPing()
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.classList.remove("toast--enter")
    this.element.classList.add("toast--exit")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
